<template>
  <el-button
    size="mini"
    @click="childclick"
    icon="el-icon-edit"
  >
    <!-- <slot>{{this.buttonName}}</slot> -->
    <slot>编辑</slot>
  </el-button>
</template>

<script>
export default {
  components: {},
  // props: {
  //   buttonName: {
  //     type: String,
  //     default: '编辑'
  //   },
  // },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    childclick() {
      this.$emit('click');
    }
  }
};
</script>
<style lang="scss" scoped>
</style>